export default __webpack_public_path__ + "static/media/arrowLeft.af031bd7.svg";